// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/place_types/housing.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/core/place_types/housing.proto.
 */
export const file_proto_model_core_place_types_housing = /*@__PURE__*/
  fileDesc("Cipwcm90by9tb2RlbC9jb3JlL3BsYWNlX3R5cGVzL2hvdXNpbmcucHJvdG8SBmNhcm1lbirfAQoQSG91c2luZ1BsYWNlVHlwZRIiCh5IT1VTSU5HX1BMQUNFX1RZUEVfVU5TUEVDSUZJRUQQABIpCiVIT1VTSU5HX1BMQUNFX1RZUEVfQVBBUlRNRU5UX0JVSUxESU5HEAESKAokSE9VU0lOR19QTEFDRV9UWVBFX0FQQVJUTUVOVF9DT01QTEVYEAISKgomSE9VU0lOR19QTEFDRV9UWVBFX0NPTkRPTUlOSVVNX0NPTVBMRVgQAxImCiJIT1VTSU5HX1BMQUNFX1RZUEVfSE9VU0lOR19DT01QTEVYEARCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw");

/**
 * Describes the enum carmen.HousingPlaceType.
 */
export const HousingPlaceTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_place_types_housing, 0);

/**
 * Housing-related place types
 *
 * @generated from enum carmen.HousingPlaceType
 */
export const HousingPlaceType = /*@__PURE__*/
  tsEnum(HousingPlaceTypeSchema);

